type SearchInput = {
 isConnected:boolean;disabled:boolean;readOnly:boolean;
 closest(selector:string):Element|null;
 getBoundingClientRect():{width:number;height:number};
};

/** A fixed footer cannot host a results panel below itself. Reuse the visible main input. */
export function dockedSearchTarget<T extends SearchInput>(source:T,inputs:readonly T[]):T {
 if(!source.closest('.storefront-handheld-footer-bar'))return source;
 return inputs.find(input=>input!==source&&input.isConnected&&!input.disabled&&!input.readOnly
  &&!input.closest('.storefront-handheld-footer-bar')
  &&input.getBoundingClientRect().width>0&&input.getBoundingClientRect().height>0)??source;
}
